import axios from 'axios'
import $store from '../../store'
import {randomWord,encrypt} from "../../until/encrypt"
// axios 配置
axios.defaults.timeout = 50000;
// axios.defaults.baseURL =  'https://testapi.epermarket.com';

// axios.defaults.baseURL =  'https://testapi.nogogo.cn';
// axios.defaults.baseURL =  'https://api.nogogo.cn';

// axios.defaults.baseURL = 'https://testapi.nogogo.cn';
// axios.defaults.baseURL = 'https://api.nogogo.cn';

// axios.defaults.baseURL = 'https://testapi.nogogo.cn';
// 正式域名
// axios.defaults.baseURL = 'https://pc.nogogo.cn';
// 新版正式
axios.defaults.baseURL = 'https://api2.nogogo.cn';
// 新版测试
// axios.defaults.baseURL = 'https://testapi-update.nogogo.cn';
axios.interceptors.request.use(config => {
  delete config.headers["api-version"];
  if(config.data.isSign){
    const {isSign,...requestData}=config.data;
		Object.keys(requestData)
		config.data=Object.assign({},$store.state.NewdefaultParams,requestData)
    // 生成签名
    const Timestamp=Date.parse(new Date())/1000;
    const NonceString=randomWord(false,32);
    const Data=config.data;
    const Sign=encrypt(Timestamp +"."+ NonceString +"."+ JSON.stringify(Data));
    // 组装数据
    let defaultParams={
      Timestamp,
      NonceString,
      Sign,
      Data:JSON.stringify(Data)
    }
    // 更改请求头
    config.headers["api-version"] = "new_pc_api";
    config.data = Object.assign({},defaultParams)
  }else{
    config.data = Object.assign({}, $store.state.defaultParams, config.data);
  }
  
  return config;
},
  err => {
    return Promise.reject(err)
  })


axios.interceptors.response.use(
  response => {
    // IE 8-9
    if (response.data == null && response.config.responseType === 'json' && response.request.responseText != null) {
      try {
        // eslint-disable-next-line no-param-reassign
        response.data = JSON.parse(response.request.responseText);
      } catch (e) {
        // ignored
      }
    }
    if (response.data.Code == -4) {
      localStorage.removeItem('Token');
      localStorage.removeItem('userInfo');
      window.location.href = "/login"

    }
    if(response.data.NonceString && response.data.Sign && response.data.Timestamp){
      const Sign = encrypt(response.data.Timestamp +"."+ response.data.NonceString +"."+ response.data.Data)
      if(Sign == response.data.Sign){
        let NewData=JSON.parse(response.request.responseText);
        let NewData2;
        try {
          NewData2=JSON.parse(NewData.Data);
        }catch(e){
          NewData2= NewData.Data;
        }
        let Obj={
          Data:NewData2,
          IsError:NewData.IsError,
          Message:NewData.Message,
          ResultCode:NewData.ResultCode
        }
        response.data=Obj
      }
      
    }
    return response.data
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
      }
    }
    return Promise.reject(error.response.data)
  });
const httpGet = function (url, param = {}, headers = {}) {
  axios.get(url, param).then((res) => {
    resolve(res.data);
  }, err => {
    reject(err.data)
  }).catch(err => {
    reject(err);
  })
}
const httpPost = function (url, data = {}, headers = {}) {
  return axios({
    method: 'post', url, data,
    transformRequest: [function (res) {
      let ret = '';
      for (let it in res) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(res[it]) + '&';
      }
      return ret
    }],
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
}

const httpPostNew = function (url, data = {}, headers = {}) {
  return axios({
    method: 'post', url, data,
    headers: {
      'Content-Type': 'application/json'
    }
  });
}

export default {
  httpGet,
  httpPost,
  httpPostNew
};



// WEBPACK FOOTER //
// ./src/plugins/axios/index.js